import init from '@fiverr-private/braze';

export default init;
